// Override with REACT_APP_API_BASE_URL (e.g. in .env.development.local) to
// point the forms at a local API.
const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://siteapi.kurr.com";

const api = `${BASE_URL}/api/kur/send-email`;
const physicianApi = `${BASE_URL}/api/kur/physician/send-email`;
const patientApi = `${BASE_URL}/api/kur/patient/send-email`;
const sponsorApi = `${BASE_URL}/api/kur/sponsor/send-email`;
const jobAPi = `${BASE_URL}/api/kur/job/apply`;
const studyEnquiyApi = `${BASE_URL}/api/kur/study/enquiry`;

const studiesData = [
  {
    studyType: "Sjogren's Syndrome Study",
    title: "Sjogren's Syndrome Study",
    states: ["Maryland"],
    cities: ["Columbia"],
    description:
      "Study to Investigate Efficacy and Safety of drug in Participants With Sjogren's Syndrome",
  },
  {
    studyType: "Covid Study",
    title: "Covid Study",
    states: ["Maryland"],
    cities: ["Columbia"],
    description:
      "Study involves testing a potential COVID-19 pill for adults at high risk",
  },
  {
    studyType: "Cardiovascular study",
    title: "Cardiovascular study",
    states: ["Maryland"],
    cities: ["Columbia"],
    description:
      "Testing a potential new treatment that may help lower the risk of heart attacks and strokes",
  },
  {
    studyType: "Bacterial Conjunctivitis Treatment study",
    title: "Bacterial Conjunctivitis Treatment study",
    states: ["Maryland"],
    cities: ["Columbia"],
    description: "Clinical Study Testing a Treatment for Red, Irritated Eyes",
  },
  {
    studyType: "Asthma Study",
    title: "Asthma Study",
    states: ["Maryland"],
    cities: ["Columbia"],
    description:
      "Asthma Study for Adults – Help Test a Treatment Aiming to Protect Long-Term Lung Function",
  },
  {
    studyType: "COPD Study",
    title: "COPD Study",
    states: ["Alabama"],
    cities: ["Bessemer", "Centreville"],
    description:
      "COPD Study for Adults – Testing a New Treatment for Moderate to Severe Symptoms",
  },
  {
    studyType: "Obesity and Diabetes Study",
    title: "Obesity and Diabetes Study",
    states: ["Alabama"],
    cities: ["Bessemer", "Centreville"],
    description: "Study for Adults With Type 2 Diabetes and Obesity",
  },
  {
    studyType: "Obesity Study",
    title: "Obesity Study",
    states: ["Alabama"],
    cities: ["Bessemer", "Centreville"],
    description: "Testing a new weight-loss shot for people without diabetes",
  },
];

const flipsnackLink =
  "https://www.flipsnack.com/E7957866AED/kur-research-introduction/full-view.html";

module.exports = {
  api,
  physicianApi,
  patientApi,
  sponsorApi,
  jobAPi,
  studiesData,
  studyEnquiyApi,
  flipsnackLink,
};
